// Test utility to verify Firebase error reporting and Telegram alerts
import errorReporter from './errorReporting';

export const testErrorReporting = async () => {
  if (process.env.NODE_ENV === 'development') {
    console.log('🧪 Testing Firebase error reporting...');
    
    try {
      // Test general error (should NOT trigger Telegram alert)
      await errorReporter.reportError(new Error('Test error - ignore'), {
        component: 'test',
        action: 'error_reporting_test',
        severity: 'low'
      });

      // Test autopay error (SHOULD trigger Telegram alert)
      console.log('\n🚀 Testing autopay error (will trigger Telegram alert in dev)...');
      await errorReporter.reportAutopayError(new Error('Test autopay error - ignore'), {
        action: 'test_autopay',
        customer_id: 'test_customer_123',
        house_number: '238'
      });

      // Test critical error (SHOULD trigger Telegram alert)
      console.log('\n🚨 Testing critical error (will trigger Telegram alert in dev)...');
      await errorReporter.reportError(new Error('Test critical error - ignore'), {
        component: 'payment',
        action: 'process_payment',
        severity: 'critical',
        customer_id: 'test_customer_456'
      });

      // Test success reporting (no alert)
      errorReporter.reportSuccess('test_action', 'test_component', {
        test_data: 'success'
      });

      console.log('\n✅ Test error reports sent to Firebase Analytics');
      console.log('📊 Check Firebase Console > Analytics > Events to verify');
      console.log('📢 Check console above for simulated Telegram alerts');
    } catch (error) {
      console.error('Error during testing:', error);
    }
  }
};

// Test just Telegram alerting
export const testTelegramAlerts = async () => {
  console.log('📢 Testing Telegram alert system...');
  
  // Simulate different alert scenarios
  const testScenarios = [
    {
      error: new Error('Autopay setup failed for user'),
      context: {
        component: 'autopay',
        action: 'create_subscription',
        severity: 'high',
        customer_id: 'WTN4S20D4KE7BCP3Q06KJTM0P4',
        house_number: '238'
      },
      description: 'House 238 autopay failure'
    },
    {
      error: new Error('Payment processing completely down'),
      context: {
        component: 'payment',
        action: 'process_payment',
        severity: 'critical'
      },
      description: 'Critical payment system failure'
    },
    {
      error: new Error('Cannot read properties of undefined (reading map)'),
      context: {
        component: 'autopay',
        action: 'fetch_customer_cards',
        severity: 'high',
        customer_id: 'multiple_customers'
      },
      description: 'The exact error we just fixed'
    }
  ];
  
  try {
    for (let i = 0; i < testScenarios.length; i++) {
      const scenario = testScenarios[i];
      console.log(`\n🎦 Scenario ${i + 1}: ${scenario.description}`);
      await errorReporter.reportError(scenario.error, scenario.context);
    }
    
    console.log('\n✅ All test scenarios completed. Check console for alert previews.');
  } catch (error) {
    console.error('Error during Telegram alert testing:', error);
  }
};

// Function to manually trigger in development console
window.testFirebaseErrorReporting = testErrorReporting;
window.testTelegramAlerts = testTelegramAlerts;

// Export main test for backwards compatibility
export default testErrorReporting;